import React from "react";
import { useSelector } from "react-redux";

import Modal from "./Modal";
import CustomSpinner from "components/Loader/CustomSpinner";

import {
  BACKGROUND_WALLET,
  MODAL_CLOSE,
  COMPLETE_TRANSACTION,
  FAILED_TRANSACTION,
} from "src/constants/images";

const Loader = ({ onClick }) => (
  <>
    <div className="heading">
      <img
        src={BACKGROUND_WALLET.SOURCE}
        alt="background"
        className="background-wallet"
      />
      <h4 className="mb-2">Connecting</h4>
      <p className="text">Please wait for a moment..</p>
    </div>
    <div className="body loading">
      <CustomSpinner />
    </div>
    <div className="footer">
      <p className="py-2">Connecting to ICONex wallet..</p>
      <p className="py-2">
        If you don't have ICONex, please
        <a
          target="_blank"
          href="https://chrome.google.com/webstore/detail/iconex/flpiciilemghbmfalicajoolhkkenfel?hl=en"
          onClick={onClick}
        >
          {" "}
          <strong> download</strong> and try again.
        </a>{" "}
        .
      </p>
      <button disabled className="btn btn-outline-secondary close">
        Close
      </button>
    </div>
  </>
);

const Success = ({ onClick, address, ledger }) => (
  <>
    <span
      onClick={() => onClick()}
      onKeyPress={(e) => e.code == "Enter" && onClick()}
      className="close-modal"
    >
      <img src={MODAL_CLOSE.SOURCE} alt="close" />
    </span>
    <div className="heading">
      <h4 className="mb-3">Congratulations !</h4>
      <p className="text">
        You are successfully connected to your {ledger ? "ledger" : ""}{" "}
        <strong> wallet.</strong>
        <br />
        <span className="text-primary address">{address}</span>
      </p>
    </div>
    <div className="body">
      <img
        src={COMPLETE_TRANSACTION.SOURCE}
        alt="transaction completed"
        className="d-block mx-auto my-3"
      />

      <button className="btn btn-outline-primary profile" onClick={onClick}>
        Close
      </button>
    </div>
  </>
);

const Error = ({ onClick }) => (
  <>
    <span
      onClick={() => onClick()}
      onKeyPress={(e) => e.code == "Enter" && onClick()}
      className="close-modal"
    >
      <img src={MODAL_CLOSE.SOURCE} alt="close" />
    </span>
    <div className="heading">
      <h4 className="mb-2 me-2 ms-md-0">Oh No! Connection Failed</h4>
      <p className="text my-3">
        We can not connect with your <strong>wallet</strong> due to some <br />
        issue. Please try again after checking your network.
      </p>
    </div>
    <div className="body">
      <span className="d-block mx-auto my-3 failed-transaction">
        <img
          src={FAILED_TRANSACTION.SOURCE}
          alt="transaction failed"
          className="mb-0"
        />
      </span>
      <button className="btn btn-outline-primary profile" onClick={onClick}>
        Close
      </button>
    </div>
  </>
);

const Cancel = ({ onClick }) => (
  <>
    <span
      onClick={() => onClick()}
      onKeyPress={(e) => e.code == "Enter" && onClick()}
      className="close-modal"
    >
      <img src={MODAL_CLOSE.SOURCE} alt="close" />
    </span>
    <div className="header">
      <h4 className="mb-2 me-2 ms-md-0">Oh No! Transaction Cancelled</h4>
      <p className="text my-3">Transaction cancelled.</p>
    </div>
    <div className="body">
      <span className="d-block mx-auto my-3 failed-transaction">
        <img
          src={FAILED_TRANSACTION.SOURCE}
          alt="transaction failed"
          className="mb-0"
        />
      </span>
      <button className="btn btn-outline-primary profile" onClick={onClick}>
        Close
      </button>
    </div>
  </>
);

const ConnectWalletModal = ({ response, onClick, isVisible, ledger }) => {
  const address = useSelector((state) => state.wallet.walletAddress);

  return (
    <Modal
      isVisible={isVisible}
      overlayClass="overlay"
      className="buying-modal card px-3 py-4"
    >
      {response.status == "success" ? (
        <>
          <Success onClick={onClick} address={address} ledger={ledger} />
        </>
      ) : response.status == "error" ? (
        <Error onClick={onClick} />
      ) : response.status == "cancel" ? (
        <Cancel onClick={onClick} />
      ) : (
        <Loader onClick={onClick} />
      )}
    </Modal>
  );
};

export default ConnectWalletModal;
